/**
 * Site read model (GET /site/stats, v0.1.166): the contract's shape, re-exported so the screen imports from one place,
 * plus the Turkish words for the source states.
 */

import type { SiteSourceStatus } from '@twin/contracts';

export type {
  SiteAiAgentCounts,
  SiteAiPage,
  SiteAiTotals,
  SiteBotEyeAgent,
  SiteBotEyeCheck,
  SiteBotEyeRun,
  SiteClickSource,
  SiteCount,
  SiteCrawler,
  SiteCrawlerCheck,
  SiteCrawlerGroup,
  SiteCrawlerRangeState,
  SiteDay,
  SiteGa4Summary,
  SiteLogSummary,
  SiteReferrer,
  SiteSearchRow,
  SiteSearchSummary,
  SiteSource,
  SiteSourceState,
  SiteSourceStatus,
  SiteStatsView,
  SiteWanted,
  SiteWantedArea,
  SiteWantedScan,
  SiteWantedSource,
} from '@twin/contracts';
export {
  SITE_AI_REFERRERS,
  SITE_BOT_EYE_AGENTS,
  SITE_BOT_EYE_PAGE_KIND_LABELS,
  SITE_BOT_EYE_PROBLEM_LABELS,
  SITE_CLICK_SOURCE_LABELS,
  SITE_CRAWLER_GROUP_LABELS,
  SITE_CRAWLER_LABELS,
  SITE_CRAWLER_RANGE_LISTS,
  SITE_OTHER_PATH,
  SITE_REFERRER_LABELS,
  SITE_SOURCE_LABELS,
  SITE_WANTED_AREA_LABELS,
  SITE_WANTED_CATALOG_LABELS,
  SITE_WANTED_SOURCE_LABELS,
} from '@twin/contracts';

export const SITE_SOURCE_STATUS_LABELS: Readonly<Record<SiteSourceStatus, string>> = Object.freeze({
  ok: 'Okunuyor',
  not_connected: 'Bağlı değil',
  error: 'Okunamadı',
  no_data: 'Veri yok',
  waiting: 'İlk okuma bekleniyor',
});
